<template>
  <MainLayout section="dunes">
    <div id="dunes" :class="$mq">
      <div id="logo">
        <img src="@/assets/imgs/logo.png" />
        <img src="@/assets/imgs/TAD.png" />
      </div>

      <div id="summary">
        <p>The Dolinde have invaded! It is up to you to deliver the mystical artifact that will stem the tide of battle.</p>

        <ul>
          <li>☀️ Surf on a flying carpet across procedurally generated levels</li>
          <li>🧞‍♂️ Battle enemies, evade genies, beat sandstorms... all while racing against the clock</li>
          <li>🎮 Collect upgrades and new carpets... each which grants a unique ability</li>
          <li>💎 And so much more!</li>
        </ul>

	<img src="@/assets/imgs/dunes/FlyingCarpet.gif" />
      </div>

      <div id="prototype">
        <p>To install the app, follow these instructions:</p>
        <ul>
          <li v-b-modal.android>🤖 <a href="#">Android</a></li>
          <li v-b-modal.windows>🪟 <a href="#">Windows</a></li>
          <li>🍎 iOS/Mac: Coming soon!</li>
        </ul>

        <br/><b-alert show variant="warning"><b>Note</b>: Game is currently in the <b>PROTOTYPE</b> phase!</b-alert>
      </div>

      <div>
        <p>For more information, see the <a href="https://docs.google.com/document/d/1vXfyYOZW7d2bphofYy6XEG57qW3RJDwGexL_k4ViRRs">Game Design Document</a></p>
      </div>
    </div>

    <b-modal id="android">
      <b>Android Instructions</b>

      <ol class="instructions">
	<li>Download the <a href="/files/The Alquas Dunes.apk">APK file</a> onto your device</li>

	<li>
          <p>Open your device <i>Settings</i> and tap <i>Apps</i> (or <i>Apps & Notifications</i>)</p>
          <img src="@/assets/imgs/dunes/android1.jpeg" />
	</li>

	<li>
          <p>Tap the three dots in the upper right corner</p>
          <img src="@/assets/imgs/dunes/android2.jpg" />
        </li>

	<li>
          <p>Tap <i>Special Access</i></p>
          <img src="@/assets/imgs/dunes/android3.jpeg" />
        </li>

	<li>
          <p>Tap <i>Install Unknown Apps</i></p>
          <img src="@/assets/imgs/dunes/android4.jpg" />
        </li>

	<li>
          <p>Tap the toggle button next to <i>My Files</i></p>
          <img src="@/assets/imgs/dunes/android5.jpeg" />
        </li>

	<li>
          <p>Open the <i>My files</i> app</p>
          <img src="@/assets/imgs/dunes/android6.jpg" />
        </li>

	<li>
          <p>Navigate to and tap on the apk you downloaded</p>
          <img src="@/assets/imgs/dunes/android7.jpg" />
        </li>

	<li>
          <p>In the Open With" popup, tap on <i>Package Installer</i></p>
          <img src="@/assets/imgs/dunes/android8.jpg" />
        </li>

	<li>
          <p>Click on <i>Install</i></p>
          <img src="@/assets/imgs/dunes/android9.jpg" />
        </li>

	<li>
          <p>After the installation has completed, tap <i>Open</i></p>
          <img src="@/assets/imgs/dunes/android10.jpg" />
        </li>
      </ol>
    </b-modal>

    <b-modal id="iOS">
      <b>iOS Instructions</b>

      <ol>
	<li>Download the zip file and extract</li>
	<li>TODO</li>
      </ol>
    </b-modal>

    <b-modal id="windows">
      <b>Windows Instructions</b>

      <ol class="instructions">
	<li>
          <p>Download the <a href="/files/The Alquas Dunes.zip">zip file</a> and extract</p>
        </li>

	<li>
          <p>Double click on <u>The Longest Tale The Alquas Dunes.exe</u></p>
          <img src="@/assets/imgs/dunes/windows1.png" />
        </li>

	<li>
          <p>If the "Windows protected your PC" popup is shown, click on "Learn More"</p>
          <img src="@/assets/imgs/dunes/windows2.jpg" />
        </li>

	<li>
          <p>Click on "Run anyway"</p>
          <img src="@/assets/imgs/dunes/windows3.jpg" />
        </li>
      </ol>
    </b-modal>
  </MainLayout>
</template>

<script>
  import MainLayout from '@/components/MainLayout'

  export default {
    name: 'Dunes',

    components: {
      MainLayout
    },
  }
</script>

<style scoped lang="scss">
@import "@/scss/custom.scss";

ul{
  width: fit-content;
  margin: auto;
  margin-top: 5px;
  padding-left: 0;
  list-style: none;
  text-align: left;
}

ol{
  padding-left: 15px;
}

#dunes{
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

#logo{
  margin-top: 30px;
}

#logo img{
  width: 275px;
  display: block;
}

#summary{
  width: 70%;
  margin: auto;
  margin-bottom: 25px;
}

#summary img{
  max-width: 70%;
  margin-top: 25px;
}

.instructions li{
  margin-bottom: 15px;
}

.instructions img{
  max-width: 250px;
  margin-left: 15px;
}

#prototype{
  width: 70%;
}
</style>
